// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { CustomEase } from "gsap/CustomEase.js"; // カスタムイージング作成が必要なときは使用

gsap.registerPlugin(ScrollTrigger);


document.addEventListener('DOMContentLoaded', function (event) {

  // --- scrollEffect ---
  if (document.querySelector('.js-slideup')) {
    document.querySelectorAll('.js-slideup').forEach(elm => {

      ScrollTrigger.create({
        toggleActions: 'play pause resume reset',
        trigger: elm,
        start: `top bottom`,
        onEnter: function () {
          elm.classList.remove('init');
        },
        onLeaveBack: function () {
          elm.classList.add('init');
        },
      });
    });
  }


  // --- TOP Features ---
  const featureSection = document.querySelector(".js-features");

  if (featureSection) {

    ScrollTrigger.matchMedia({

      "(min-width: 769px)": function () {

        const items = gsap.utils.toArray(".js-features__item");
        const sectionHeight = items.length * 100;

        gsap.set(featureSection, {
          height: `${sectionHeight}vh`
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: featureSection,
            start: "top-=40 top",
            end: `+=${sectionHeight}%`,
            scrub: true,
            pin: ".js-features__sticky"
          }
        });

        items.forEach((item, i) => {

          if (i !== 0) {
            tl.to(items[i - 1], { autoAlpha: 0, duration: 0.2 });
          }

          tl.to(item, { autoAlpha: 1, duration: 0.2 });

          if (i === items.length - 1) {
            tl.to({}, { duration: 0.5 });
          }

        });

      }

    });

  }

});

